import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ChatWidgetManager = () => {
  const location = useLocation();

  useEffect(() => {
    const hideChatRoutes = ['/login','/register','/credentials'];

    const manageChatVisibility = () => {
      if (!window.Kustomer) {
        setTimeout(manageChatVisibility, 100);
        return;
      }


      try {
        if (hideChatRoutes.includes(location.pathname)) {
          if (typeof window.Kustomer.close === 'function') {
            window.Kustomer.close();
          } else {
            console.error('Kustomer.close is not available');
          }
          document.body.classList.add('hide-kustomer-chat');
        } else {
          if (typeof window.Kustomer.start === 'function') {
            window.Kustomer.start({
              brandId: "5e1b5be5a8e2a30019a77d9d"
            });
          }
          document.body.classList.remove('hide-kustomer-chat');
        }
      } catch (err) {
        console.error('Error managing chat visibility:', err);
      }
    };

    manageChatVisibility();
  }, [location.pathname]);

  return null;
};

export default ChatWidgetManager;